import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-427c3368"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "news-slider" }
const _hoisted_2 = { class: "top-cont container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "16",
    height: "14",
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0.499961 6.99997C0.499961 7.33149 0.631658 7.64943 0.866078 7.88386C1.1005 8.11828 1.41844 8.24997 1.74996 8.24997H11.65L8.36663 11.5333C8.14583 11.7703 8.02562 12.0837 8.03134 12.4075C8.03705 12.7313 8.16824 13.0403 8.39726 13.2693C8.62628 13.4984 8.93525 13.6296 9.25909 13.6353C9.58293 13.641 9.89634 13.5208 10.1333 13.3L15.55 7.88331C15.784 7.64893 15.9155 7.33122 15.9155 6.99997C15.9155 6.66872 15.784 6.35101 15.55 6.11664L10.1333 0.699971C10.0189 0.57716 9.88086 0.478656 9.72752 0.410336C9.57419 0.342016 9.40867 0.30528 9.24083 0.302319C9.07299 0.299357 8.90628 0.330231 8.75063 0.3931C8.59498 0.455968 8.45359 0.549543 8.3349 0.66824C8.2162 0.786938 8.12262 0.928328 8.05976 1.08398C7.99689 1.23962 7.96601 1.40634 7.96898 1.57418C7.97194 1.74201 8.00867 1.90754 8.07699 2.06087C8.14531 2.2142 8.24382 2.3522 8.36663 2.46664L11.65 5.74997L1.74996 5.74997C1.05996 5.74997 0.499961 6.30997 0.499961 6.99997Z",
      fill: "black"
    })
  ])
], -1))
const _hoisted_4 = { class: "swiper-container" }
const _hoisted_5 = { class: "swiper-wrapper" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "img" }
const _hoisted_8 = {
  draggable: "false",
  class: "abs-img",
  alt: "News Image"
}
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "top-cont short-header container" }
const _hoisted_11 = { class: "center" }
const _hoisted_12 = { class: "shorts container" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, null, -1))
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  class: "abs-img",
  alt: "Short image"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask last" }, null, -1))

import { store } from '@/store/store';
import Swiper from 'swiper';
import { device } from "@/modules/breakpoints"
import { Ref, onMounted, ref } from 'vue';
import news from '@/jsons/news.json'
import shorts from '@/jsons/shorts.json'
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsSlider',
  setup(__props) {

const Store = store();
const sliders: Ref<HTMLElement[]> = ref([]);

const router = useRouter();

let navTimeOut: number | undefined = undefined

const mySwiper = ref();
const initSwiper = (): void => {
    mySwiper.value = new Swiper('.news-slider .swiper-container', {
        // Configure Swiper options here
        slidesPerView: 2.5,
        speed: 800,
        freeMode: true,
        spaceBetween: 33,
        slidesOffsetBefore: 34,
        breakpoints: {
            320: {
                slidesOffsetBefore: 12,
                slidesPerView: 1.5,
                spaceBetween: 15,
            },
            767: {
                slidesPerView: 1.5,
                spaceBetween: 20,
            },
            1023: {
                slidesOffsetBefore: 34,
                spaceBetween: 33,
                slidesPerView: 2.5,
            }
        }
    });
    mySwiper.value.init();
    mySwiper.value.on('sliderMove', () => {
        Store.setActiveMouse(false)
        sliders.value.forEach((item: any) => {
            item.style.transform = 'scale(0.9)';
        })
    })
    mySwiper.value.on('touchEnd', () => {
        sliders.value.forEach((item: any) => {
            item.style.transform = 'scale(1)';
        })
    })
}
const navigateNews = (): void => {
    Store.setIsNavigate(true);
    window.clearTimeout(navTimeOut)
    navTimeOut = window.setTimeout(() => {
        router.push('/videos');
    }, Store.getNavLoaderTime + 200)
}

const getIframeUrl = (url: any): any => {
    return url.match(/watch\?v=([^&]+)/)[1];
}
const getshortFrameUrl = (url: any) => {
    let regex = /vi\/([^\/]*)\//;
    let match = url.match(regex);
    let id = match ? match[1] : null;
    return id;
}

const shuffleArray = (array: any) => {
    // Create a copy of the array
    let newArray = array.slice();

    // Fisher-Yates shuffle algorithm
    for (let i = newArray.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }

    return newArray;
}

onMounted(() => {
    initSwiper();
})

return (_ctx: any,_cache: any) => {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "center",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (navigateNews()))
      }, [
        _createElementVNode("p", null, _toDisplayString(_unref(Store).getCurrentLang == "GE" ? "ვიდეოები" : "Videos"), 1),
        _hoisted_3
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(news).slice(0, 10), (video, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "swiper-slide",
            key: index,
            ref_for: true,
            ref_key: "sliders",
            ref: sliders,
            style: {"transition":"transform 0.4s"}
          }, [
            _createElementVNode("div", {
              onClick: ($event: any) => (_unref(Store).openVideoPopup(getIframeUrl(video.video)))
            }, [
              _createElementVNode("div", {
                class: "box",
                onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_unref(Store).setActiveMouse(true))),
                onMousemove: _cache[2] || (_cache[2] = ($event: any) => (_unref(Store).setActiveMouse(true))),
                onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_unref(Store).setActiveMouse(false)))
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("img", _hoisted_8, null, 512), [
                    [_directive_lazy, { src: _unref(Store).getWindowWidth <= _unref(device).tablet ? video.thumbMobile : video.thumbDesktop, loading: require('@/assets/loading.gif') }]
                  ])
                ]),
                _createElementVNode("p", _hoisted_9, _toDisplayString(video.title), 1)
              ], 32)
            ], 8, _hoisted_6)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", _hoisted_11, [
        _createElementVNode("p", null, _toDisplayString(_unref(Store).getCurrentLang == "GE" ? "მოკლე ვიდეოები" : "Shorts"), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (row, index) => {
        return _createElementVNode("div", {
          class: "row",
          key: index
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["inner-row", { 'bottom': index === 1 || index === 3 }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shuffleArray(_unref(shorts)), (short, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "short",
                key: index,
                onClick: ($event: any) => (_unref(Store).openVideoPopup(getshortFrameUrl(short.thumbnail))),
                onMouseenter: _cache[4] || (_cache[4] = ($event: any) => (_unref(Store).setActiveMouse(true))),
                onMousemove: _cache[5] || (_cache[5] = ($event: any) => (_unref(Store).setActiveMouse(true))),
                onMouseleave: _cache[6] || (_cache[6] = ($event: any) => (_unref(Store).setActiveMouse(false)))
              }, [
                _withDirectives(_createElementVNode("img", _hoisted_15, null, 512), [
                  [_directive_lazy, { src: short.thumbnail, loading: require('@/assets/loading.gif') }]
                ])
              ], 40, _hoisted_14))
            }), 128))
          ], 2)
        ])
      }), 64)),
      _hoisted_16
    ])
  ]))
}
}

})